import { render } from "./OrderViewTable.vue?vue&type=template&id=f13dfd2e&scoped=true"
import script from "./OrderViewTable.vue?vue&type=script&lang=js"
export * from "./OrderViewTable.vue?vue&type=script&lang=js"

import "./OrderViewTable.vue?vue&type=style&index=0&id=f13dfd2e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f13dfd2e"]])

export default __exports__